import { createFileRoute, Link } from "@tanstack/react-router";
import { Helmet } from "react-helmet-async";
import { Quote } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/testimonials")({
  component: TestimonialsPage,
});

const reviews = [
  { q: "Amazing quality! Delivery was fast.", n: "Ali Raza", c: "Lahore" },
  { q: "Very satisfied with my purchase.", n: "Ayesha Khan", c: "Karachi" },
  { q: "Product exactly as shown.", n: "Usman Tariq", c: "Islamabad" },
  { q: "Highly recommended store.", n: "Fatima Noor", c: "Faisalabad" },
  { q: "Good customer support.", n: "Bilal Ahmed", c: "Rawalpindi" },
  { q: "Will shop again!", n: "Sana Malik", c: "Multan" },
  { q: "Affordable and reliable.", n: "Hamza Ali", c: "Peshawar" },
  { q: "Excellent service.", n: "Hira Sheikh", c: "Sialkot" },
  { q: "Loved the product quality.", n: "Imran Shah", c: "Quetta" },
  { q: "Very professional store.", n: "Zain Ali", c: "Hyderabad" },
];

function TestimonialsPage() {
  return (
    <>
      <Helmet>
        <title>Customer Reviews</title>
        <meta name="description" content="Read what customers across Pakistan are saying about Trendora Marts." />
        <meta property="og:title" content="Customer Reviews — Trendora Marts" />
      </Helmet>
      <section className="bg-card text-foreground py-16 text-center border-b border-border">
        <div className="container mx-auto px-4">
          <p className="text-gold uppercase text-xs tracking-[0.3em] mb-3">Reviews</p>
          <h1 className="text-4xl sm:text-5xl font-serif">Loved by Customers Across Pakistan</h1>
        </div>
      </section>

      <section className="container mx-auto px-4 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <article key={i} className="relative bg-card border border-border rounded-lg p-8 hover-lift">
              <Quote className="h-8 w-8 text-gold/30 absolute top-5 right-5" />
              <div className="text-gold mb-4">{"★★★★★"}</div>
              <p className="text-foreground/90 italic leading-relaxed mb-6">"{r.q}"</p>
              <div className="pt-4 border-t border-border">
                <p className="font-semibold">{r.n}</p>
                <p className="text-sm text-muted-foreground">{r.c}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-14">
          <p className="text-muted-foreground mb-4">Ready to experience the Trendora Marts difference?</p>
          <Button asChild variant="gold" size="lg"><Link to="/shop">Shop Now</Link></Button>
        </div>
      </section>
    </>
  );
}
